import { render, staticRenderFns } from "./BarSpinner.vue?vue&type=template&id=6f5851c6&scoped=true"
import script from "./BarSpinner.vue?vue&type=script&lang=js"
export * from "./BarSpinner.vue?vue&type=script&lang=js"
import style0 from "./BarSpinner.vue?vue&type=style&index=0&id=6f5851c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5851c6",
  null
  
)

export default component.exports